import React from 'react';
// import sections
import Hero from '../components/sections/Hero';

import Iome from '../components/sections/Home';
import Tokenomics from "../components/sections/Tokenomics"
import Ai from "../components/sections/Ai"

const Home = () => {

  return (
    <>
      <Iome topDivider />
      <Tokenomics topDivider/>
      <Ai topDivider/>
      <Hero topDivider />
   
    </>
  );
}

export default Home;